"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M38.7083 33.75C38.4885 33.7753 38.2659 33.751 38.0568 33.6789C37.8477 33.6068 37.6574 33.4887 37.5 33.3333L25 20.0833L12.5 33.3333C12.3506 33.4858 12.1723 33.6069 11.9756 33.6896C11.7788 33.7722 11.5676 33.8148 11.3541 33.8148C11.1407 33.8148 10.9294 33.7722 10.7327 33.6896C10.5359 33.6069 10.3577 33.4858 10.2083 33.3333C9.9157 33.0404 9.75134 32.6432 9.75134 32.2292C9.75134 31.8151 9.9157 31.418 10.2083 31.125L23.875 16.6667C24.0222 16.518 24.1974 16.4 24.3905 16.3195C24.5836 16.2389 24.7907 16.1975 25 16.1975C25.2092 16.1975 25.4163 16.2389 25.6094 16.3195C25.8025 16.4 25.9777 16.518 26.125 16.6667L39.8333 31.0208C40.1259 31.3138 40.2903 31.7109 40.2903 32.125C40.2903 32.5391 40.1259 32.9362 39.8333 33.2292C39.6897 33.3863 39.5163 33.5132 39.3231 33.6026C39.13 33.6921 38.921 33.7422 38.7083 33.75Z",
    fill: fill
  }));
};

exports["default"] = _default;